export const SEARCH_URL =
  'https://en.wikipedia.org/w/api.php?format=json&origin=*&action=query&generator=search&gsrlimit=10&prop=extracts&exintro&explaintext&exsentences=1&exlimit=max&gsrsearch=';
export const PAGE_URL = 'https://en.wikipedia.org/?curid=';
